import { InputAsyncSelect, InputSelectControl } from '../../Select'
import { getMessageTemplates } from '../MessageTemplate.api'

import {
  getMessageTemplateSelectApiData,
  toMessageTemplateSelectItems,
} from './MessageTemplateSelect.utils'

function MessageTemplateSelect({
  Control = InputSelectControl,
  getData = getMessageTemplates,
  getDataItems = getMessageTemplateSelectApiData,
  toPreparedItems = toMessageTemplateSelectItems,
  ...restProps
}) {
  return (
    <InputAsyncSelect
      {...restProps}
      Control={Control}
      getData={getData}
      getDataItems={getDataItems}
      toPreparedItems={toPreparedItems}
    />
  )
}

export default MessageTemplateSelect
